import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from './../redux/hooks';

// -- Routes

import { acceptAccessRequest } from '../routes/general/authentication';

// -- Components 

import Box from '@mui/material/Box';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import Logo from '../components/general/navBar/Logo';
import Page from '../components/general/containers/Page';

const AccessRequest: React.FC = () => {

    const { patientAccessRequestId } = useParams<{ patientAccessRequestId: string }>();

    const colors = useAppSelector(state => state.theme.colors);

    const [isRequestAccepted, setIsRequestAccepted] = useState(false); 

    // -- 

    const handleRequest = async () => { 

        const res = await acceptAccessRequest(patientAccessRequestId); 

        if (res?.data.status === 200) { 

            setIsRequestAccepted(true); 

        }; 

    }; 

    // -- 


    useEffect(() => { 

        if (patientAccessRequestId) { 

            handleRequest(); 

        }; 

    },[patientAccessRequestId]); 

    // -- 

    return (

        <Page>

            { isRequestAccepted && <VerifiedUserIcon sx={{ fontSize: 100, color: colors?.accessRequestVerifiedIcon }} />}

            <Logo />

        </Page>

  );
};

export default AccessRequest;